import React from 'react';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Header, { headerItemsLabels } from '../../../Common/Header/header';
import CreatePlyTypeDialog from './CreatePlyTypeDialog/createPlyTypeDialog';
import PlyTypesViewGrid from './PlyTypesViewGrid/plyTypesViewGrid';
import { PL_DialogWrapper } from 'infrastructure/js/components/Dialog/dialog';
import { MatSettingsMenuItemsIds } from '../../../../enums/navigationMenuItemsIds';
import { gridsNames } from '../../../../enums/gridsNames.js';
import { ImportAcceptFileTypes, ImportTypes } from '../../../../enums/importTypes';

export default class PlyTypesView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.plytypes.view.');
  }

  componentDidMount() {
    this.props.actions.matSettingsPageActions.onSelectedMenuItemChanged(MatSettingsMenuItemsIds.NAV_ELEMENT_PLY_TYPES);
  }

  getHeaderItems() {
    let { actions } = this.props;
    let hasRows = this.props.sHasRows;
    let selectedRowsData = this.props.sSelectedRowsData;

    let items = {
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id: 'create',
          label: headerItemsLabels.CREATE,
          icon: 'pl pl-icon-add',
          action: actions.header.onCreatePlyTypeClick,
        },
        {
          id: 'edit',
          label: headerItemsLabels.EDIT,
          icon: 'pl pl-edit-icon',
          disabled: !(hasRows && selectedRowsData.size === 1),
          action: actions.header.onEditPlyTypeClick,
          actionData: selectedRowsData.get(0),
        },
      ],
      kebab: {
        menuItems: [
          {
            id: 'importPlyTypes',
            label: headerItemsLabels.IMPORT_PLY_TYPES,
            action: actions.header.importItems,
            disabled: false,
            actionData: {
              importTypes: [ImportTypes.IMPORT_PLY_TYPES],
              acceptFileTypes: [ImportAcceptFileTypes.CSV],
              parentComponent: actions.reload
            }
          },
          {
            id: 'exportPlyTypes',
            label: headerItemsLabels.EXPORT_PLY_TYPES,
            action: actions.header.exportItems,
            disabled: !hasRows,
            actionData: { gridName: gridsNames.ADMINISTRATION_MAT_SETTINGS_PLY_TYPES }
          },
          {
            id:'remove',
            label: headerItemsLabels.DELETE,
            action: actions.header.onRemovePlyTypesClick,
            disabled: (!selectedRowsData || selectedRowsData.size === 0),
            actionData:  selectedRowsData,
          },
        ]
      }
    };

    return items;
  }

  reloadPage = () => {
    this.props.actions.init(true);
  };

  render() {
    let title = this.labels.get('title');
    let headerItems = this.getHeaderItems();
    return (
      <div className="administration-view">
        <div className="title">{title}</div>

        <Header {...headerItems} />

        <PlyTypesViewGrid actions={{ ...this.props.actions.plyTypesViewGridActions, ...this.props.actions.fetchEntitiesActions }} />

        <PL_DialogWrapper
          dialogComponent={CreatePlyTypeDialog}
          show={this.props.sCreatePlyTypeDialogData.get('show')}
          actions={this.props.actions.createPlyTypeDialogActions}
          sData={this.props.sCreatePlyTypeDialogData}
          reloadParentComponent={this.reloadPage}
        />
      </div>
    );
  }
}
